import { createStore } from 'vuex'
import { OrganizationsStore } from './modules/organizations'
import { ComputersStore } from './modules/computers'
import { LicensesStore } from './modules/licenses'
import { GroupsStore } from './modules/groups'
import { UsersStore } from './modules/users'
import { ScheduleStore } from './modules/schedule'
import { BalanceStore } from './modules/balance'

export const store = createStore({
  modules: {
    orgs: OrganizationsStore,
    computers: ComputersStore,
    licenses: LicensesStore,
    groups: GroupsStore,
    users: UsersStore,
    schedule: ScheduleStore,
    balance: BalanceStore
  }
})
